<template>
  <div>
    <div
      :class="
        'header-desktop' +
        ($route.path !== '/sobre' ? ' header-desktop-home' : '')
      "
    >
      <v-container class="py-5">
        <div class="d-flex align-center">
          <router-link to="/">
            <img :src="logo" class="header-logo" />
          </router-link>

          <v-spacer />

          <div class="navbar-nav">
            <v-btn
              v-for="({ text, to }, i) in menu"
              :key="i"
              :to="to"
              :class="`nav-link white--text` + (i > 0 ? ` ml-6` : ``)"
              active-class="active"
              tile
              text
            >
              {{ text }}
            </v-btn>
          </div>

          <v-spacer />

          <div class="navbar-social">
            <v-btn
              :class="'nav-link primary--text' + (i > 0 ? ' ml-6' : '')"
              :href="link"
              target="_blank"
              icon
              v-for="({ text, link, icon }, i) in social"
              :key="i"
              :title="text"
            >
              <v-icon> {{ icon }} </v-icon>
            </v-btn>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import { getSocial } from "../../../config";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
    social() {
      return getSocial(this);
    },
    informations() {
      return this.$rest("informations").item;
    },
  },
};
</script>

<style scoped>
.header-desktop {
  background: transparent;
  position: relative;
  z-index: 100;
}

.header-desktop-home {
  background-color: var(--v-primary-base);
}

.header-desktop .header-logo {
  height: 81px;
}

.navbar-nav .nav-link {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
}

.navbar-nav .nav-link.active {
  font-weight: 900;
}

.navbar-social .nav-link {
  background-color: #ffffff;
}

.navbar-social .nav-link .v-icon {
  font-size: 18px;
}

.navbar-social .nav-link:hover {
  opacity: 0.7;
}
</style>
